/* ZoneCellFormatters.js */

"use strict";

module.exports = {
    checkboxFormatter,
    displayNameFormatter,
    engineFormatter,
    engineCountFormatter,
    currentState,
    deleteButtonFormatter,
};

/**
 * Wrap cell text in a span that truncates with an ellipsis similar to how we do it for CMDB but with
 * proper class name on span
 * @param {*} text - value to display
 * @returns {string} - span markup
 */
function ellipsisTextCell(text) {
    const span = document.createElement("span");
    span.classList.add("cell-text-ellipsis");
    span.textContent = text ?? "";
    span.setAttribute("title", span.textContent);
    return span.outerHTML;
}

function checkboxFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(true);
    }
    return checkbox.outerHTML;
}

function displayNameFormatter(row, cell, value /*, columnDef, dataContext*/) {
    return ellipsisTextCell(value);
}

function engineFormatter(row, cell, value, columnDef, dataContext) {
    let text = "Defunct Location";
    if (value) {
        let engineLocations = dataContext.renderer.model.getEngineZones();
        let engineLocation = engineLocations[value];
        if (engineLocation) {
            text = engineLocation.name;
        }
    }
    return ellipsisTextCell(text);
}

function engineCountFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let countDiv = document.createElement("div");
    countDiv.classList.add("engine-count");
    countDiv.innerHTML = value;
    return countDiv.outerHTML;
}

function currentState(row, cell, value, columnDef, dataContext) {
    let orgState = value;
    if (!dataContext.enabled) {
        orgState = orgState + " (Disabled for org)";
    }
    return orgState;
}

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    if (dataContext.inherited || !dataContext.authorized) {
        return "";
    } else {
        const button = document.createElement("base-icon-gl");
        button.dataset.icon = "common.trash_bin";
        button.setDarkTheme(true);

        button.setAttribute("aria-label", `delete ${dataContext.name}`);
        button.setAttribute("role", "button");

        button.dataset.uuid = dataContext.id;
        button.dataset.action = "delete";

        return button.outerHTML;
    }
}
